const STORAGE_KEY = 'qupro-theme';

function apply(theme) {
  document.documentElement.setAttribute('data-theme', theme);
}

export const init = ({ commit }) => {
  const saved = localStorage.getItem(STORAGE_KEY);
  const theme = saved === 'dark' ? 'dark' : 'light';
  commit('SET_THEME', theme);
  apply(theme);
};

export const toggle = ({ state, commit }) => {
  const next = state.current === 'dark' ? 'light' : 'dark';
  commit('SET_THEME', next);
  localStorage.setItem(STORAGE_KEY, next);
  apply(next);
};
